var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileAvatarLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3032_9469)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 24.0001C48 31.6118 44.4567 38.3958 38.9293 42.7924C34.8316 46.0529 29.6442 48 24.0001 48C18.356 48 13.1686 46.0529 9.07073 42.7924C3.54352 38.3958 0 31.6118 0 24.0001C0 10.7454 10.7457 0 24.0001 0C37.2546 0 48 10.7454 48 24.0001Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0003 31.6506C29.1518 31.6506 33.3278 27.4745 33.3278 22.3231C33.3278 17.1717 29.1518 12.9956 24.0003 12.9956C18.8489 12.9956 14.6729 17.1717 14.6729 22.3231C14.6729 27.4745 18.8489 31.6506 24.0003 31.6506Z",
    fill: "#8E8D8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9288 42.7926C34.8312 46.053 29.6438 48.0002 23.9997 48.0002C18.3556 48.0002 13.1682 46.053 9.07031 42.7926C12.071 38.3844 17.6339 35.4238 23.9997 35.4238C30.3655 35.4238 35.9288 38.3837 38.9288 42.7926Z",
    fill: "#8E8D8D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3032_9469"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileAvatarLight);
export default __webpack_public_path__ + "static/media/Profile Avatar Light.171b2dbf9587df2ba0980fb8a2c5bdbd.svg";
export { ForwardRef as ReactComponent };